import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            redirect: "/directory/"
        },
        {
            path: "/directory/:slug?",
            name: "directory-show",
            component: () => import("./views/directory/DirectoryShow")
        },
        {
            path: "/document/add/:slug?",
            name: "document-add",
            component: () => import("./views/document/DocumentAdd")
        },
        {
            path: "/document/search",
            name: "document-search",
            component: () => import("./views/document/DocumentSearch")
        },
        {
            path: "/login",
            name: "login",
            component: () => import("./views/security/Login")
        },
        {
            path: "*",
            name: "about",
            component: () => import("./views/404")
        }
    ],
});
